import { quickProperty, designToken } from '../component-tokens';
import { sizeAttributes } from './utils';
import { borderBase } from './common';
const dialogOuterMargin = 48;
const innerPaddingToken = { padding: quickProperty('0 24px') };
const baseHeaderToken = {
    name: 'header',
    attributes: Object.assign({ 'min-height': quickProperty('70px'), display: quickProperty('flex'), 'align-items': quickProperty('center'), 'justify-content': quickProperty('space-between') }, innerPaddingToken),
    children: [
        {
            name: 'title',
            attributes: {
                margin: quickProperty('0'),
                font: designToken('heading-small'),
                color: designToken('text-01'),
            },
        },
        {
            name: 'close',
            tag: 'svg',
            attributes: Object.assign(Object.assign({}, sizeAttributes('16px')), { 'pointer-events': quickProperty('none') }),
        },
    ],
};
const baseContentToken = {
    name: 'content',
    attributes: Object.assign({ margin: quickProperty('0'), font: designToken('body-medium'), color: designToken('text-01'), 'flex-grow': quickProperty('1'), 'overflow-y': quickProperty('auto'), 'border-top': quickProperty('solid 1px'), 'border-bottom': quickProperty('solid 1px'), 'border-color': quickProperty('transparent') }, innerPaddingToken),
    children: [
        {
            name: 'overflow',
            attributes: {
                'border-color': designToken('border'),
            },
        },
    ],
};
const baseFooterToken = {
    name: 'footer',
    attributes: Object.assign({ 'min-height': quickProperty('76px'), display: quickProperty('flex'), 'align-items': quickProperty('center'), 'flex-direction': quickProperty('row-reverse') }, innerPaddingToken),
    children: [
        {
            name: 'footer-text',
            attributes: {
                margin: quickProperty('0'),
                font: designToken('body-small'),
                color: designToken('text-01'),
            },
        },
    ],
};
const dialogWrapper = {
    name: 'wrapper',
    attributes: {
        opacity: quickProperty('0'),
        transform: quickProperty(`scale(1.1)`),
        visibility: quickProperty('hidden'),
        transition: quickProperty('var(--goto-transition-dialog-out)'),
        display: quickProperty('flex'),
        'justify-content': quickProperty('center'),
        'align-items': quickProperty('center'),
    },
    children: [
        {
            name: 'visible',
            attributes: {
                opacity: quickProperty('1'),
                transform: quickProperty(`scale(1)`),
                visibility: quickProperty('visible'),
                transition: quickProperty('var(--goto-transition-dialog-in)'),
            },
        },
    ],
};
export const dialogTokens = {
    name: 'dialog',
    tag: 'chameleon-dialog',
    reactImports: 'Dialog',
    attributes: Object.assign(Object.assign({}, borderBase), { 'box-sizing': quickProperty('border-box'), 'min-height': quickProperty('215px'), 'max-height': quickProperty(`calc(100vh - ${dialogOuterMargin * 2}px)`), 'background-color': designToken('ui-01'), 'border-radius': quickProperty('4px'), 'border-color': designToken('ui-02'), 'min-width': quickProperty('318px'), width: quickProperty('480px'), 'max-width': quickProperty(`calc(100vw - ${dialogOuterMargin * 2}px)`), 'box-shadow': designToken('elevation-300'), display: quickProperty('flex'), 'flex-direction': quickProperty('column') }),
    children: [baseHeaderToken, baseContentToken, baseFooterToken, dialogWrapper],
    sizes: [
        { name: 'small', attributes: { width: quickProperty('400px') } },
        { name: 'large', attributes: { width: quickProperty('640px') } },
        { name: 'xlarge', attributes: { width: quickProperty('860px') } },
        {
            name: 'fullScreen',
            attributes: {
                border: quickProperty('none'),
                width: quickProperty('100vw'),
                'max-width': quickProperty('100vw'),
                height: quickProperty('100vh'),
                'max-height': quickProperty('100vh'),
                'border-radius': quickProperty('none'),
            },
            children: [
                {
                    name: 'content',
                    attributes: {
                        'border-top': quickProperty('solid 1px'),
                        'border-bottom': quickProperty('solid 1px'),
                        'border-color': designToken('neutral-150'),
                    },
                },
            ],
        },
    ],
};
